import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useQualificationDimensionProgress = (groupId, userId) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['qualificationDimensionProgress', groupId, userId],
    queryFn: async () => {
      let url = `${prefix}/qualification-scorecards/group/${groupId}/dimensions`;
      if (userId) url += `?userId=${userId}`;
      const result = await restClient({ url });
      return result;
    },
    enabled: !!groupId,
    staleTime: 0,
    cacheTime: 0,
  });
};
